<template>
    <div>
        <template v-if="loaded">
            <country-report type="language" title="Language pairs KPIs" />
            <country-report type="industry" title="Industry sectors KPIs" />
            <country-report type="document" title="Document types KPIs" />
            <country-report type="qa" title="QA models KPIs" />
            <country-report type="evaluation" title="Evaluation methods KPIs" />
        </template>
        <preload-block :preloaderStatus="true" v-else></preload-block>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  components: {
    'country-report': () => import('../reportItem/index.vue'),
    'preload-block': () => import('@/components/preloader/index.vue'),
  },
  data: () => ({
    loaded: false,
  }),
  created () {
    return Promise.all([
      this.$store.dispatch('GET_LANGUAGES'),
      this.$store.dispatch('GET_INDUSTRY'),
      this.$store.dispatch('GET_COUNTRIES'),
      this.$store.dispatch('GET_DOCUMENT_TYPES'),
      this.$store.dispatch('GET_QA_METHODS'),
    ]).finally(() => {
      this.$nextTick(() => {
        this.loaded = true;
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    this.loaded = false;
    this.$nextTick(() => {
      next();
    });
  },
});
</script>

<style lang="scss">

</style>
